import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthContext from "contexts/AuthContext";
import { isDropoffStore, shouldShowShippingTab } from "lib/utils";
import checkin from "assets/checkin.svg";
import calendar from "assets/calendar.svg";
import tradeins from "assets/tradeins.svg";
import appointment_selected from "assets/appointment_selected.svg";
import appointments from "assets/appointmentIcon.svg";
import checkin_selected from "assets/checkin_selected.svg";
import tradeins_selected from "assets/tradeins_selected.svg";
import createshipment from "assets/createshipment.svg";
import createshipment_selected from "assets/createshipment_selected.svg";
// import signup_store from "assets/signup_store.svg";
// import signup_store_selected from "assets/signup_store_selected.svg";

const BottomBar = ({ showScheduleTab }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const { user } = useContext(AuthContext);
  const isDropoff = isDropoffStore(user);
  const showShipping = shouldShowShippingTab(user);

  const tabs = [
    {
      name: "Trade-Ins",
      icon: tradeins,
      icon_selected: tradeins_selected,
      href: t("urls.store_trade_ins"),
    },
  ];

  // Add Shipments tab only for CO/AR users
  if (showShipping) {
    tabs.unshift({
      name: "Shipments",
      icon: createshipment,
      icon_selected: createshipment_selected,
      href: t("urls.store_shipping"),
    });
  }

  // Only add Appointments tab if not a dropoff store
  if (!isDropoff) {
    tabs.push({
      name: "Appointments",
      icon: appointments,
      icon_selected: appointment_selected,
      href: t("urls.store_schedule"),
    });
  }

  tabs.push({
    name: "Check In",
    icon: checkin,
    icon_selected: checkin_selected,
    href: t("urls.store_check_in"),
  });

  if (showScheduleTab) {
    tabs.push({
      name: "Schedule",
      icon: calendar,
      icon_selected: calendar,
      href: t("urls.store_schedule"),
    });
  }

  const handleTabClick = (tabHref) => {
    setActiveTab(tabHref);
  };

  return (
    <div className="flex py-large bg-white w-full z-10 dark:bg-gray-800 fixed bottom-0 justify-center items-center border-t border-gray-300 dark:border-gray-700">
      <div className="flex flex-row items-center justify-between px-4 w-full">
        {tabs.map((tab, index) => (
          <Link key={index} to={tab.href} className="flex-1">
            <div
              className={`flex flex-col items-center cursor-pointer ${
                activeTab === tab.href
                  ? "text-blue"
                  : "text-tertiary hover:text-blue dark:text-gray-400 dark:hover:text-gray-50"
              }`}
              onClick={() => handleTabClick(tab.href)}
            >
              <img
                src={activeTab === tab.href ? tab.icon_selected : tab.icon}
                alt={tab.name}
                className={`sm:h-12 sm:w-12 h-8 w-8`}
              />
              <span className="sm:text-sm text-xs mt-x-small">{tab.name}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

BottomBar.propTypes = {
  showScheduleTab: PropTypes.bool,
};

BottomBar.defaultProps = {
  showScheduleTab: false,
};

export default BottomBar;
